
import {userMixin} from "@/mixins/userMixin";

export default {
  name: 'LeftMenu',
  props: {
    miniVariant: {
      type: Boolean,
      required: true,
    },
  },
  mixins: [
    userMixin
  ],
  data() {
    return {
      clipped: true,
      drawer: false,
      elementsWithDivider: ['New sale', 'Services', 'Orders', 'Register', 'Reports', 'Configuration', 'CMS'],
      isOpen: false,
    }
  },
  computed: {
    menuItems() {
      return this.allowViewingPrices
        ? this.$auth.user.menuItems
        : this.$auth.user.menuItems.filter((item) => item.text !== 'Register')
    },
  },
  mounted() {
    if (process.client) {
      window.addEventListener('resize', this.checkTablet);
    }
  },
  beforeDestroy() {
    if (process.client) {
      window.removeEventListener('resize', this.checkTablet);
    }
  },
  methods: {
  },
}
